import React, { useState, useRef, useEffect } from 'react';
import AddCardForm from '../CardDropdown/CardAddForm';
import deleteIcon from "../../../styles/icons/close.png";
import ApexIcon from "../../../styles/icons/apexIcon.svg";
import { alertAPI, ALERT_EVENTS } from '../../../services/api'

import { useTranslation } from "react-i18next";

const CardDropdown = ({ selectedCard, onCardAdd, onCardOtp, onCardDelete, onCardSelect, cards = [] }) => {
  const { t } = useTranslation("exchange");

  const [isOpen, setIsOpen] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [cardToDelete, setCardToDelete] = useState(null);
  const dropdownRef = useRef(null);

  const cardData = cards.length > 0 ? cards : [];
  const selected = selectedCard ?? cardData[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setShowAddForm(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      alertAPI.trigger(ALERT_EVENTS.CARD_VIEW_OPEN);
    }
  }, [isOpen]);

  //Update this when multicard support will come
  //const getCardIcon = () => '💳';

  const getCardColor = (type) => {
    switch (type?.toLowerCase()) {
      //case 'visa': return '#1A1F71';
      //case 'mastercard': return '#EB001B';
      //case 'uzcard': return '#00A651';
      case 'humo': return '#111111';
      default: return '#111111';
    }
  };

  const handleDeleteClick = (card, e) => {
    e.stopPropagation();
    setCardToDelete(card);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (cardToDelete) {
      onCardDelete(cardToDelete.id);
      setCardToDelete(null);
      setShowDeleteModal(false);
    }
  };

  const cancelDelete = () => {
    setCardToDelete(null);
    setShowDeleteModal(false);
  };

  const handleCardSelect = (card) => {
    onCardSelect?.(card);
    setIsOpen(false);
  };

  const handleAddFormSubmit = (newCard) => {
    return onCardAdd?.(newCard);
  };

  const handleOtpSubmit = (otp) => {
    onCardOtp?.(otp);
    setShowAddForm(false);
    setIsOpen(false);
  };

  const handleAddFormClose = () => {
    setShowAddForm(false);
  };

  return (
    <>
      <div className="relative w-full" ref={dropdownRef}>
        <button
          className={`w-full flex items-center justify-between rounded-xl px-4 py-3 transition-all duration-300 cursor-pointer border-2 ${isOpen ? 'border-blue-500 bg-gray-50' : 'border-transparent bg-gray-100 hover:bg-gray-200'
            }`}
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          {selected && (
            <div className="flex-1">
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-7 rounded-md flex items-center justify-center text-white font-bold text-sm"
                  style={{ backgroundColor: getCardColor(selected.card_type) }}
                >
                  <img src={ApexIcon} alt="Apex" className="w-8 h-5" />
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="text-base font-semibold text-gray-800">{selected.masked_pan}</span>
                  <span className="text-xs text-gray-500">{selected.card_type}</span>
                </div>
              </div>
            </div>
          )}
          <span className={`text-xs text-gray-400 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
            ▼
          </span>
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-xl shadow-lg z-50 max-h-96 overflow-y-auto animate-fadeIn">
            {!showAddForm ? (
              <>
                {/* Список существующих карт */}
                {cardData.map((card) => (
                  <div
                    key={card.id}
                    className={`w-full flex flex-wrap items-center justify-between px-4 py-3 border-b border-gray-100 transition-colors duration-200 
                      ${selected.id === card.id ? 'bg-blue-50' : 'hover:bg-gray-100'}`}
                  >
                    <button
                      className="flex-1 flex items-center gap-3 text-left"
                      onClick={() => handleCardSelect(card)}
                    >
                      <div
                        className="w-10 h-7 rounded-md flex items-center justify-center text-white font-bold text-sm"
                        style={{ backgroundColor: getCardColor(card.card_type) }}
                      >
                        <img src={ApexIcon} alt="Apex" className="w-8 h-5" />
                      </div>
                      <div className="flex flex-col gap-0.5">
                        <span className="text-base font-semibold text-gray-800">{card.masked_pan}</span>
                        <span className="text-xs text-gray-500">{card.card_type}</span>
                      </div>
                      {card.isDefault && (
                        <span className="ml-2 bg-blue-500 text-white text-[11px] px-2 py-0.5 rounded-full font-medium">
                          {t("BY_DEFAULT")}
                        </span>
                      )}
                    </button>

                    <button
                      onClick={(e) => handleDeleteClick(card, e)}
                      className="ml-auto text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded-full transition-colors flex-shrink-0"
                      title={t("DELETE_CARD")}
                    >
                      <img
                        src={deleteIcon}
                        alt={t("DELETE")}
                        className="w-3 h-3 filter brightness-0 saturate-100"
                        style={{ filter: 'invert(26%) sepia(89%) saturate(1583%) hue-rotate(331deg) brightness(71%) contrast(97%)' }}
                      />
                    </button>
                  </div>
                ))}

                {/* Кнопка добавления карты */}
                <button
                  type="button"
                  onClick={() => setShowAddForm(true)}
                  className="w-full flex items-center gap-3 px-4 py-3 border-t border-gray-100 text-blue-500 font-medium hover:bg-gray-100 transition-colors"
                >
                  <span className="w-6 h-6 flex items-center justify-center border-2 border-blue-500 rounded-full font-bold">+</span>
                  <span>{t("ADD_CARD")}</span>
                </button>
                <p className="px-4 pb-3 pt-3 text-xs text-green-500 text-center">
                  {t("APEX_ONLY_CARDS_NOTE")}
                </p>
              </>
            ) : (
              /* Форма добавления карты */
              <AddCardForm
                onClose={handleAddFormClose}
                onSubmit={handleAddFormSubmit}
                onOtpSubmit={handleOtpSubmit}
              />
            )}
          </div>
        )}
      </div>

      {/* Modal подтверждения удаления */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]">
          <div className="bg-white rounded-xl p-6 mx-4 max-w-sm w-full animate-fadeIn">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {t("DELETE_CARD_ASK")}
            </h3>
            <p className="text-gray-600 mb-4">
              {t("DELETE_CARD_ARE_YOU_SURE")} {cardToDelete?.masked_pan}? {t("THIS_ACTION_CANT_BE_CANCELED")}.
            </p>
            <div className="flex gap-3">
              <button
                onClick={confirmDelete}
                className="flex-1 bg-red-500 text-white rounded-lg py-2.5 font-medium hover:bg-red-600 transition-colors"
              >
                {t("YES_DELETE")}
              </button>
              <button
                onClick={cancelDelete}
                className="flex-1 bg-gray-200 text-gray-800 rounded-lg py-2.5 font-medium hover:bg-gray-300 transition-colors"
              >
                {t("DELETE")}
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default CardDropdown;